<template>
  <div class='portSettle'>
<!--    <div class='tabs' v-if='!flag'>
      <div @click='typeFun(0)' class='left' :class='{ active: planType === 0 }'>操作费</div>
      <div @click='typeFun(1)' :class='{ active: planType === 1 }'>燃油费</div>
      <div @click='typeFun(2)' :class='{ active: planType === 2 }'>堆存费</div>
      <div @click='typeFun(3)' class='right' :class='{ active: planType === 3 }'>过驳费（资源车）</div>
    </div>
    <div class='tabs' v-else>
      <div @click='typeFun(0)' style='border-radius: 10px' :class='{ active: planType === 0 }'>操作费
      </div>
    </div>-->
    <div class='tabs'>
      <div @click='typeFun(0)' class="left"  :class='{ active: planType === 0}'>港口费用结算</div>
      <div @click='typeFun(2)' :class='{ active: planType === 2 }'>堆存费</div>
      <div @click='typeFun(5)' class="right" :class='{ active: planType === 5 }'>港口费用补结算</div>
    </div>
    <div class='componentsContainer'>
      <operation v-if='planType === 0' ref='operation' />
      <electrify v-else-if='planType === 1' ref='electrify' />
      <stockpile v-else-if='planType === 2' />
      <refute-resources-car v-else-if='planType === 3' />
      <!--  港口费用补结算   -->
      <port-supplementary v-if="planType === 5"/>
    </div>
  </div>
</template>

<script>
  import operation from '@/views/settle/supplier/components/operation.vue';
  import electrify from '@/views/settle/supplier/components/electrify.vue';
  import stockpile from '@/views/settle/supplier/components/stockpile.vue';
  import RefuteResourcesCar from '@/views/settle/supplier/components/refuteResourcesCar';
  import { getSessionStore } from '@/config/mUtils';
  import PortSupplementary from "@/views/settle/supplier/components/portSupplementary.vue";

  export default {
    components: {
      PortSupplementary,
      RefuteResourcesCar,
      operation,
      electrify,
      stockpile,
    },

    data() {
      return {
        planType: 0,
        flag: false,
      };
    },
    mounted() {
      this.getPermissions();
    },
    methods: {
      getPermissions() {
        if (getSessionStore('userDept') !== '[]') {
          this.flag = JSON.parse(getSessionStore('userDept'))[0].id === 'da7cfb6cbfe64425bc6e50f16ad64b58' || false;
        }
      },
      typeFun(val) {
        this.planType = val;
        this.$nextTick(() => {
          switch (val) {
            case 0:
              //this.$refs.operation._supplierPortOperationPageList();
              break;
            case 1:
             // this.$refs.electrify._refuelingpowerList();
              break;
          }
        });
      },
    },
  };
</script>


<style lang='scss' scoped>
  .portSettle {
    width: 100%;
    padding: 20px 15px 0 25px;
    display: flex;
    flex-direction: column;

    .tabs {
      float: left;
      margin-left: 20px;
      margin-top: 2px;
      display: flex;
      justify-content: space-between;
      width: 550px;
      margin-bottom: 20px;

      div {
        //background: #ccc;
        width: 120px;
        height: 30px;
        line-height: 30px;
        color: #48599E;
        text-align: center;
        font-size: 13px;
        cursor: pointer;
        border: 1px solid #48599E;
        font-weight: 700;
        transition: all .3s;
      }

      .left {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
      }

      .right {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        margin-right: 250px;
      }

      .active {
        background: #48599E;
        color: #fff;
      }
    }

    .componentsContainer {
      width: 100%;

      .electrify {
        padding: 0;
      }
    }

    ::v-deep {
      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #FFFFFF;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
      }
    }
  }
</style>
